// Lumeda PDP — interactions
// 1. Sticky header/footer CTA reveal on scroll past hero
// 2. Gallery thumbnail click → swap main image
// 3. Quantity +/- buttons
// 4. Sticky CTA "Add to cart" → submit the in-page form
// 5. Variant option click → select hidden id

(function () {
  'use strict';

  // ----- Sticky CTA reveal -----
  const sticky = document.querySelector('[data-sticky-cta]');
  const hero = document.getElementById('pdp-hero');
  if (sticky && hero) {
    sticky.removeAttribute('hidden');
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          sticky.dataset.active = e.isIntersecting ? 'false' : 'true';
        });
      },
      { rootMargin: '-200px 0px 0px 0px', threshold: 0 }
    );
    obs.observe(hero);
  }

  // ----- Sticky CTA → submit form -----
  document.querySelectorAll('[data-sticky-add]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const form = document.getElementById('lumedaProductForm');
      if (!form) return;
      const submitBtn = form.querySelector('button[type=submit]');
      if (submitBtn && !submitBtn.disabled) form.requestSubmit(submitBtn);
    });
  });

  // ----- Gallery thumb click -----
  const mainImg = document.getElementById('lumedaGalleryMainImg');
  if (mainImg) {
    document.querySelectorAll('.lumeda-pdp__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const url = thumb.dataset.mediaUrl;
        if (!url) return;
        // Clear srcset/sizes so the new .src is actually displayed
        // (with srcset present, the browser ignores .src and keeps the old image)
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = url;
        document.querySelectorAll('.lumeda-pdp__thumb').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  // ----- Quantity +/- -----
  document.querySelectorAll('[data-qty-action]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.lumeda-pdp__qty-input');
      if (!input) return;
      const cur = parseInt(input.value, 10) || 1;
      const min = parseInt(input.min, 10) || 1;
      const max = parseInt(input.max, 10) || 99;
      const next = btn.dataset.qtyAction === 'inc' ? Math.min(cur + 1, max) : Math.max(cur - 1, min);
      input.value = next;
    });
  });

  // ----- Variant option select (single-option products only — multi-option needs more wiring) -----
  document.querySelectorAll('.lumeda-pdp__variant').forEach((variantGroup) => {
    const buttons = variantGroup.querySelectorAll('.lumeda-pdp__variant-option');
    const selectedLabel = variantGroup.querySelector('.lumeda-pdp__variant-selected');
    buttons.forEach((b) =>
      b.addEventListener('click', () => {
        buttons.forEach((x) => x.classList.remove('is-selected'));
        b.classList.add('is-selected');
        if (selectedLabel) selectedLabel.textContent = b.dataset.optionValue;
        // NOTE: full variant-id resolution would require a /variants.json fetch — out of scope for v1; theme.js Dawn handles native variant pickers if user prefers.
      })
    );
  });
})();


/* =====================================================================
   UGC VIDEO CAROUSEL — controls
   ===================================================================== */
(function () {
  function initUGC() {
    var sections = document.querySelectorAll('.lumeda-pdp__ugc');
    sections.forEach(function (section) {
      var track = section.querySelector('[data-ugc-track]');
      var prev  = section.querySelector('.lumeda-pdp__ugc-nav--prev');
      var next  = section.querySelector('.lumeda-pdp__ugc-nav--next');
      if (!track) return;

      // ------- arrow scroll -------
      function scrollByCard(dir) {
        var card = track.querySelector('.lumeda-pdp__ugc-card');
        if (!card) return;
        var step = card.getBoundingClientRect().width + 18; // gap
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });

      // ------- per-card behavior -------
      var cards = section.querySelectorAll('.lumeda-pdp__ugc-card');
      cards.forEach(function (card) {
        var video = card.querySelector('[data-ugc-video]');
        var muteBtn = card.querySelector('[data-ugc-mute]');
        var playBtn = card.querySelector('[data-ugc-play]');
        var media = card.querySelector('.lumeda-pdp__ugc-media');
        if (!video) return;

        var muteOn  = card.querySelector('.lumeda-pdp__ugc-mute-on');
        var muteOff = card.querySelector('.lumeda-pdp__ugc-mute-off');
        var playIco = card.querySelector('.lumeda-pdp__ugc-play-icon');
        var pauseIco = card.querySelector('.lumeda-pdp__ugc-pause-icon');

        function syncPlayIcon() {
          if (video.paused) {
            card.classList.add('is-paused');
            if (playIco) playIco.style.display = '';
            if (pauseIco) pauseIco.style.display = 'none';
          } else {
            card.classList.remove('is-paused');
            if (playIco) playIco.style.display = 'none';
            if (pauseIco) pauseIco.style.display = '';
          }
        }
        function syncMuteIcon() {
          if (video.muted) {
            if (muteOn) muteOn.style.display = '';
            if (muteOff) muteOff.style.display = 'none';
          } else {
            if (muteOn) muteOn.style.display = 'none';
            if (muteOff) muteOff.style.display = '';
          }
        }
        video.addEventListener('play', syncPlayIcon);
        video.addEventListener('pause', syncPlayIcon);
        video.addEventListener('volumechange', syncMuteIcon);
        syncPlayIcon();
        syncMuteIcon();

        if (muteBtn) {
          muteBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            // mute all other videos when unmuting this one
            if (video.muted) {
              document.querySelectorAll('[data-ugc-video]').forEach(function (v) {
                if (v !== video) v.muted = true;
              });
            }
            video.muted = !video.muted;
          });
        }
        function togglePlay(e) {
          if (e) e.stopPropagation();
          if (video.paused) video.play().catch(function(){});
          else video.pause();
        }
        if (playBtn) playBtn.addEventListener('click', togglePlay);
        if (media)   media.addEventListener('click', togglePlay);
      });

      // ------- IntersectionObserver: pause off-screen, play on-screen -------
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var card = entry.target;
            var video = card.querySelector('[data-ugc-video]');
            if (!video) return;
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              card.classList.add('is-active');
              video.play().catch(function(){});
            } else {
              card.classList.remove('is-active');
              video.pause();
            }
          });
        }, { root: track, threshold: [0, 0.6, 0.9] });
        cards.forEach(function (c) { io.observe(c); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUGC);
  } else {
    initUGC();
  }
  document.addEventListener('shopify:section:load', initUGC);
})();
